<template>
  <div v-if="pointDatas" class="database-overlap-graph-page row-block" :style="{ width: '100%' }">
    <div class="database-overlap-graph-result">{{ (Math.floor(fixNumber(pointDatas.result, 0.0001) * 10000) / 100 + '%').padStart(3, ' ') }}</div>
    <div class="database-overlap-graph-line-container col-block width-full" :style="{ flex: 1 }">
      <div class="database-overlap-graph-line-block row-block" :class="[type]" v-for="(type) in ['s', 'd', 'all']" :key="type" :style="{ flex: 1 }">
        <div
          class="database-overlap-graph-line"
          v-for="(_, i) in pointDatas[type].filter((_, i) => i)"
          :key="type + i"
          :style="{ width: (pointDatas[type][i + 1] - pointDatas[type][i]) * 100 + '%' }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { fixNumber, sortData } from '../../constants/global/util'

export default {
  props: {
    points: {
      type: Object,
      required: true
    },
    result: {
      type: Number,
      default: () => null
    }
  },
  computed: {
    pointDatas () {
      let allPoints = sortData([...(this.points['s'] || []), ...(this.points['d'] || [])], p => p, 'asc')
      if (allPoints.length !== 4) return
      let start = allPoints[0]
      let range = allPoints[3] - allPoints[0]
      let sPoints = [allPoints[0], ...this.points['s'], allPoints[3]].map(p => (p - start) / range)
      let dPoints = [allPoints[0], ...this.points['d'], allPoints[3]].map(p => (p - start) / range)
      allPoints = allPoints.map(p => (p - start) / range)
      return {
        all: allPoints,
        s: sPoints,
        d: dPoints,
        result: this.result !== null ? this.result : (allPoints[2] - allPoints[1])
      }
    },
    // global
    fixNumber () { return fixNumber }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/case/databaseOverlapGraph.vue